import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { AppState } from '../store/appState';
import { getAuthenticated, getPreventAuthInfo, getQueryCount } from '../store/wallet';
import { AUTH_DATA_KEY, AUTH_REASON, WALLET_STORAGE_KEY } from '../constants';
import { Logger } from './logger.service';
import { PreventAuthInfo } from '../../global';
import { AuthenticateAction, SetWalletRedirectUriAction } from '../actions/wallet.actions';
import { AppModeService } from './app-mode.service';
import { ChangeActivePage, ShowSideMenu } from '../actions/appSettings.actions';
import { AuthService } from './auth.service';
import { StorageService } from './storage.service';

@Injectable()
export class WalletGuardService implements CanActivate {

  private authenticated: boolean = false;
  private isDesktopMode: boolean = false;
  private queryCount: number;
  private preventInfo: PreventAuthInfo;
  private showSideMenu = [
    '/home-page/established',
    '/wallet/settings',
    '/vault-intro',
    '/trade',
    '/prime',
    '/wallet-connect'
  ];
  private appLinks = [
    'home-page',
    'trade',
    'settings',
  ];
  constructor(
    private nav: NavController,
    private store: Store<AppState>,
    private appMode: AppModeService,
    private authService: AuthService,
    private storage: StorageService,
  ) {
    this.store.select(getAuthenticated).subscribe(authenticated => this.authenticated = authenticated);
    this.store.select(getQueryCount).subscribe(count => this.queryCount = count);
    this.store.select(getPreventAuthInfo).subscribe((preventInfo: PreventAuthInfo) => {
      this.preventInfo = preventInfo;
    });
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    Logger.info('GUARD ROUTE', route, state, this.preventInfo, this.queryCount);
    const url = state.url;

    // if window href has query param oauth_state_id, then we are coming from oauth
    const oauthStateId = route.queryParams['oauth_state_id'];
    if (oauthStateId) {
      Logger.info('GUARD ROUTE OAUTH url', url);
      this.store.dispatch(new SetWalletRedirectUriAction(url));
    }
    const authData = await this.storage.get(AUTH_DATA_KEY);
    if (!authData) {
      await this.nav.navigateRoot('setup/intro');
      return false;
    }
    if (!this.authenticated) {
      if (this.queryCount === 0) { // first time login
        // Logger.info('guard first login');
        await this.authService.openAuthPinModal();
        // await this.nav.navigateForward(['/auth'], { skipLocationChange: true });
      } else if (!this.preventInfo.preventAuthOnResume || this.preventAuthOnResumeTimedOut()) { // relogin
        // Logger.info('guard reauth', route.url.join(''));
        await this.authService.openAuthPinModal(AUTH_REASON.RE_AUTHENTICATE);
        // await this.nav.navigateForward(['/auth', AUTH_REASON.RE_AUTHENTICATE], { skipLocationChange: true, queryParams: { url } });
      }
      return false;
    }
    // check the wallet is Activated
    const checkWallet = await this.storage.get(WALLET_STORAGE_KEY);

    if (!checkWallet) {
      return false;
    }
    // Show side menu based on url
    if (this.authenticated && this.showSideMenu.some(text => url.includes(text))) {
      this.store.dispatch(new ShowSideMenu(true));
    } else {
      this.store.dispatch(new ShowSideMenu(false));
    }
    // TODO: hightlight active menu
    this.appLinks.map(menu => {
      if (url.includes(menu)) {
        this.store.dispatch(new ChangeActivePage(menu));
      }
    });
    return true;
  }

  private preventAuthOnResumeTimedOut() {
    Logger.info('preventAuthOnResumeTimedOut check', this.preventInfo);
    if (this.preventInfo.unauthenticatedTime && this.preventInfo.preventAuthDuration > 0) {
      const preventAuthDurationMs = this.preventInfo.preventAuthDuration * 1000;
      Logger.info('unauth time:', this.preventInfo.unauthenticatedTime);
      Logger.info('unauth prevent auth duration:', this.preventInfo.preventAuthDuration);
      const unauthDuration = (Date.now() - this.preventInfo.unauthenticatedTime);
      Logger.info('unauth duration', unauthDuration);
      if (unauthDuration >= preventAuthDurationMs) {
        return true;
      } else {
        this.store.dispatch(new AuthenticateAction());
        return false;
      }
    }

    return false;
  }

}
